import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('estimate');

export default {
  computed: {
    ...mapState({
      settings(state) {
        return this.$route.name === 'editEstimate' ? state.historicalSettings : state.settings;
      },
    }),
  },
};
